import React from 'react';
import './HomeTitleAndDescription.scss';

const HomeTitleAndDescription = ({ data }) => {
  return (
    <div className="od-home-title-and-des" style={{ background: data?.background }}>
      <div className="od-home-title-and-des__title">{data?.title}</div>
    </div>
  );
};

export default HomeTitleAndDescription;
